module.exports = __webpack_public_path__ + "img/fr_success_2.03ad3620.png";